export default __webpack_public_path__ + "1c16fb5.png";